import React from 'react';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import { Divider, IconButton, ListItemButton, Stack, Typography } from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import { useBundles } from '../../../hooks/inventory/useBundles';
import SearchBox from '../../common/forms/SearchBox';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Bundles from '../../inventory/modals/Bundles';
import BundleItems from '../../inventory/modals/BundleItems';

export default function InventoryBundleSearch({addButtonCallback, open, onClose, mode = 'inventory'}) {
    const { t } = useTranslation('common'); 

    const handleClose = () => {
        onClose();
        resetParent();
    };

    const [viewOpen, setViewOpen] = React.useState(false);

    const [selectedBundle, setSelectedBundle] = React.useState(null);

    const handleListItemClick = (item) => {
      setViewOpen(true);
      setSelectedBundle(item);
    };

    const handleAddItemClick = (item) => {
      addButtonCallback(item);
      onClose();
      resetParent();
    };

    const { showSnackbar } = useSnackbar();

    const { bundles, loading, loadMore, searchFunction, resetParent } = useBundles(open, 1, 10);

    return (
      <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
          <DialogTitle>
          <Stack spacing={2}>
            <Typography variant="h6">Search Bundles</Typography>
            <SearchBox searchFunction={searchFunction} resetParent={resetParent} />
            <Divider />
          </Stack>
          </DialogTitle>

          <DialogContent>
            <>
              <List sx={{ minHeight: 500 }}>
                {bundles?.data?.map((bundle) => (
                  <ListItem
                      key={bundle.id}
                      secondaryAction={
                      <Box sx={{ ml: 2, display: 'flex', alignItems: 'right' }}>
                        <IconButton>
                          {mode === 'inventory' ?
                          <AddShoppingCartIcon 
                            onClick={() => handleAddItemClick(bundle)}
                            fontSize='large' 
                            color='primary'
                          />
                          : 
                          <AddIcon 
                            onClick={() => handleAddItemClick(bundle)}
                            fontSize='large' 
                            color='primary'
                          />
                          }
                        </IconButton>
                      </Box>
                      }
                  >
                    <ListItemButton onClick={() => handleListItemClick(bundle)}>
                      <ListItemText
                        primary={
                          <>
                            <Typography component="span" variant="body1" >
                            {`${bundle.name}`}
                            </Typography>
                        </>
                        }
                        secondary={ 
                        <>
                            <Typography component="span" variant="body2" >
                            {`${bundle.items.length} item(s)`}
                            </Typography>
                        </>
                        }
                      />
                    </ListItemButton>
                  </ListItem>
                  ))}
              </List>

              {/* Load More only shows if more pages exist */}
              {bundles?.pagination?.page < bundles?.pagination?.totalPages && (
                <Box sx={{ textAlign: 'center', mt: 2 }}>
                  <IconButton 
                      onClick={loadMore}
                      sx={{
                          width: '100%',              // fill container width
                          justifyContent: 'center',   // center the icon horizontally
                          color: 'primary.main',      // use theme's primary color
                      }}
                  >
                      <KeyboardArrowDownIcon />
                  </IconButton>
                </Box>
              )}
              </>
          </DialogContent>
          <DialogActions>
            {mode === 'inventory' ? 
            <Bundles mode='button' onCloseCallback={resetParent} />
            : null }
            <div style={{flex: '1 0 0'}} />
            <Button onClick={handleClose}>{ mode === 'inventory' ? "Back to Cart" : "Close" }</Button>
          </DialogActions>
        </Dialog>
        <BundleItems 
          mode="view"
          onAddItemSuccess={null}
          onSaveQuantitySuccess={null}
          onRemoveItemSuccess={null}
          bundle={selectedBundle}
          open={viewOpen}
          onClose={() => setViewOpen(false)}
        />
    </React.Fragment>
  );
}